import React from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../../assets/svg/icons/common/CaretRight";
import Row from "./Row";

function BatchDataTable({ data = [] }) {
  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}></th>
            <th className={style.header_cell}>#</th>
            <th className={style.header_cell}>Batch</th>
            <th className={style.header_cell}>Batch Id</th>
            <th className={style.header_cell}>Terminal ID</th>
            <th className={style.header_cell}>Trans. CNT</th>
            <th className={style.header_cell}>Key Entry CNT</th>
            <th className={style.header_cell}>Sales</th>
            <th className={style.header_cell}>Returns</th>
            <th className={style.header_cell}>Net Amount</th>
            <th className={style.header_cell}>Adj Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            return <Row data={row} key={index} />;
          })}
        </tbody>
      </table>
    </div>
  );
}

export default BatchDataTable;
